import { atom } from "recoil";

export const CallLogState = atom({
    key: "callLogAtomState",
    default: false
});
